<template>
  <div
    class="w-full flex items-center mx-auto p-4 bg-gradient-to-t from-navigation to-primaire shadow-md"
  >
    <!-- Colonne gauche : Logo et bouton burger -->
    <div
      class="max-w-7xl w-2/12 flex flex-row items-center"
    >
      <button
        v-if="!isSidebarOpen"
        @click="toggleSidebar"
        class="ml-2 sm:ml-5 p-2 bg-tertiaire text-primaire hover:bg-primaire hover:text-tertiaire rounded"
        aria-label="Ouvrir le menu latéral"
        title="Menu"
      >
        <font-awesome-icon icon="bars" class="text-xl sm:text-2xl" />
      </button>
      <div
        v-if="!isSidebarOpen"
        class="w-auto ml-[10%] sm:ml-[12%] lg:ml-6[6%] mt-24 sm:mt-32 absolute"
      >
        <router-link to="/">
          <h1>
            <span class="hidden">Animaux de la Seconde Chance - Matane</span
            ><img
              src="/src/assets/images/logo.svg"
              alt="logo"
              class="h-32 sm:h-52 rounded-lg p-2 mt-16 mb-4 sm:mb-auto sm:mt-auto" 
              title="Animaux de la seconde chance - Matane"
            />
          </h1>
        </router-link>
      </div>
    </div>

    <!-- Colonne droite : Médias sociaux et contact + bouton déconnexion -->
    <div
      class="w-10/12 flex justify-end items-center space-x-4"
    >
      <ul class="flex gap-4 items-center">
         <!-- Bouton install visible uniquement sur desktop/tablette -->
        <li class="hidden md:block">
          <BoutonInstall />
        </li>
        <li>
          <router-link
            to="/"
            class="flex items-center fill-primaire text-primaire bg-tertiaire hover:bg-action group rounded-3xl"
            active-class="bg-primaire text-secondaire"
            aria-label="Accueil"
            title="Accueil"
          >
            <font-awesome-icon
              icon="home"
              class="w-6 h-6 p-2 sm:p-1 text-primaire transition duration-75 dark:text-primaire dark:group-hover:text-tertiaire"
            />
          </router-link>
        </li>
        <li>
          <a
            href="https://www.facebook.com/animauxsecondechance"
            target="_blank"
            aria-label="Suivez-nous sur Facebook"
            title="Suivez-nous sur Facebook"
            rel="noopener noreferrer"
          >
            <font-awesome-icon
              icon="fa-brands fa-facebook"
              class="text-4xl sm:text-3xl text-tertiaire hover:text-action hover:bg-tertiaire hover:rounded-full"
            />
          </a>
        </li>
        <li
          class="mt-1 sm:mt-0 bg-tertiaire rounded-full flex justify-center items-center h-8 w-8"
        >
          <router-link
            to="/nous-joindre"
            class="flex items-center p-2 mr-2 sm:p-1 fill-primaire text-primaire bg-tertiaire group rounded-3xl"
            active-class="bg-primaire text-secondaire"
            aria-label="Contactez-nous"
            title="Contactez-nous"
          >
            <font-awesome-icon
              :icon="['far', 'envelope']"
              class="text-xl text-primaire hover:text-action"
            />
          </router-link>
        </li>
        <li
          class="mr-8 sm:mr-10 mt-1 sm:mt-0 bg-tertiaire rounded-full flex justify-center items-center h-8 w-8"
        >
          <router-link
            to="/admin"
            class="flex items-center p-1.5 sm:p-1 text-primaire bg-tertiaire group rounded-3xl"
            active-class="bg-primaire text-secondaire"
            aria-label="Accéder à l'administration"
            title="Administration"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 fill-current text-primaire hover:text-action"
              viewBox="0 0 24 24"
            >
              <path
                d="M12 12c2.21 0 4-1.79 4-4S14.21 4 12 4 8 5.79 8 8s1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
              />
            </svg>
          </router-link>
        </li>
      </ul>

      <!-- Bouton Déconnexion qui s'affiche uniquement si admin connecté -->
      <button
        v-if="adminAuth.adminConnecte"
        @click="deconnexion"
        class="bg-action text-white px-4 py-2 rounded hover:bg-orange-600 transition duration-300"
        aria-label="Déconnexion de l'administrateur"
        title="Déconnexion"
      >
        Déconnexion
      </button>
    </div>
  </div>
</template>

<script setup>
import { isSidebarOpen, toggleSidebar } from "../store/storeSideBar.js";
import { useAdminAuth } from "../store/storeAdminAuth.js";
import { getAuth, signOut } from "firebase/auth";
import BoutonInstall from "../composants/BoutonInstall.vue";
import { useRouter } from "vue-router";

const adminAuth = useAdminAuth();
const router = useRouter();

const deconnexion = async () => {
  try {
    await signOut(getAuth());
    adminAuth.deconnexionAdmin();
    console.log("Déconnexion réussie");
    // Optionnel: redirection si besoin avec router.push('/')
    router.push("/admin"); // Redirige vers la page d'administration ou une autre page
  } catch (error) {
    console.error("Erreur lors de la déconnexion :", error);
  }
};
</script>

<style scoped>
.span-bg {
  background-color: white;
  padding-right: 0.5rem;
  border-top-left-radius: 1.5rem;
  border-bottom-right-radius: 1.5rem;
  font-weight: bold;
}
</style>
